export default class Document {
    static init() {
        window.addEventListener('DOMContentLoaded', () => {
            document.body.classList.add('loaded');
        });

        this.setDocumentWidth();
        window.addEventListener('resize', this.setDocumentWidth.bind(this));
    }

    static setDocumentWidth() {
        document.documentElement.style.setProperty(
            '--document-width',
            `${document.documentElement.clientWidth}px`
        );
    }
}
